import { F as e, g as t, h as n, q as r, t as i, v as a, w as o } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as s } from "./ButtonTooltip.ce-Cd_TCG5Y.js";
//#region src/webcomponents/common/icons/ArrowRight.ce.vue
var c = {}, l = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "16",
	height: "16",
	viewBox: "0 0 16 16",
	fill: "inherit",
	"aria-hidden": "true"
};
function u(t, r) {
	return e(), a("svg", l, [...r[0] ||= [n("path", {
		d: "M10.5642 8.75826H3.28958C3.07681 8.75826 2.89719 8.68509 2.75075 8.53875C2.60442 8.39231 2.53125 8.2127 2.53125 7.99992C2.53125 7.78714 2.60442 7.60753 2.75075 7.46109C2.89719 7.31475 3.07681 7.24159 3.28958 7.24159H10.5642L7.45292 4.13042C7.30103 3.97842 7.22719 3.80025 7.23142 3.59592C7.23564 3.39159 7.31369 3.21348 7.46558 3.06159C7.61758 2.9207 7.79575 2.84814 8.00008 2.84392C8.20442 2.8397 8.38258 2.91353 8.53458 3.06542L12.9346 7.46542C13.0091 7.54009 13.0636 7.62298 13.0981 7.71409C13.1325 7.80509 13.1498 7.90037 13.1498 7.99992C13.1498 8.09948 13.1325 8.19475 13.0981 8.28575C13.0636 8.37687 13.0091 8.45975 12.9346 8.53442L8.53058 12.9383C8.38703 13.0818 8.21164 13.1536 8.00442 13.1536C7.79719 13.1536 7.61758 13.0818 7.46558 12.9383C7.31369 12.7864 7.23775 12.6061 7.23775 12.3976C7.23775 12.189 7.31369 12.0088 7.46558 11.8568L10.5642 8.75826Z",
		fill: "inherit"
	}, null, -1)]]);
}
var d = /*#__PURE__*/ i(c, [["render", u]]), f = {}, p = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "16",
	height: "16",
	viewBox: "0 0 16 16",
	fill: "inherit",
	"aria-hidden": "true"
};
function m(t, r) {
	return e(), a("svg", p, [...r[0] ||= [n("path", {
		d: "M5.4356 8.75868L8.54693 11.8698C8.69882 12.0218 8.77265 12.2 8.76843 12.4043C8.76421 12.6087 8.68615 12.7868 8.53426 12.9387C8.38226 13.0796 8.2041 13.1521 7.99976 13.1563C7.79543 13.1606 7.61726 13.0867 7.46526 12.9348L3.06526 8.53485C2.99071 8.46018 2.93621 8.37729 2.90176 8.28618C2.86732 8.19518 2.8501 8.0999 2.8501 8.00035C2.8501 7.90079 2.86732 7.80551 2.90176 7.71451C2.93621 7.6234 2.99071 7.54051 3.06526 7.46585L7.46926 3.06201C7.61282 2.91846 7.78821 2.84668 7.99543 2.84668C8.20265 2.84668 8.38226 2.91846 8.53426 3.06201C8.68615 3.2139 8.7621 3.39412 8.7621 3.60268C8.7621 3.81124 8.68615 3.99151 8.53426 4.14351L5.4356 7.24201H12.7103C12.923 7.24201 13.1027 7.31518 13.2491 7.46151C13.3954 7.60796 13.4686 7.78757 13.4686 8.00035C13.4686 8.21312 13.3954 8.39274 13.2491 8.53918C13.1027 8.68551 12.923 8.75868 12.7103 8.75868H5.4356Z",
		fill: "inherit"
	}, null, -1)]]);
}
var h = /*#__PURE__*/ i(f, [["render", m]]), g = /*#__PURE__*/ i(/* @__PURE__ */ o({
	__name: "NavigationButton.ce",
	props: {
		disabled: { type: Boolean },
		label: { type: String },
		tooltipPosition: { type: String },
		direction: { type: String }
	},
	emits: ["click"],
	setup(n) {
		return (i, a) => (e(), t(s, {
			class: "button",
			"tooltip-position": n.tooltipPosition,
			label: n.label,
			disabled: n.disabled,
			onClick: a[0] ||= (e) => i.$emit("click")
		}, {
			default: r(() => [n.direction === "next" ? (e(), t(d, { key: 0 })) : (e(), t(h, { key: 1 }))]),
			_: 1
		}, 8, [
			"tooltip-position",
			"label",
			"disabled"
		]));
	}
}), [["styles", ["*{--pix-neutral-800:#253858;color:var(--pix-neutral-800)}.button{border:1px var(--pix-neutral-800) solid;aspect-ratio:1;width:32px;height:32px;fill:var(--pix-neutral-800);background:0 0;border-radius:100%;justify-content:center;align-items:center;padding:4px;display:flex}.button:hover{background:#c3d0ff}.button:active{background:#cdd1d9}"]]]);
//#endregion
export { g as t };
